<template>
    <div
        class="restart-chat-button"
    >
        <button
            type="button"
            @click="restartChat"
        >
            Nieuwe chat starten
        </button>
    </div>
</template>

<script setup lang="ts">
    import Chat from '@/chat/Chat';

    const chat = Chat.getInstance();

    function restartChat() {
        chat.restartChat();
    }
</script>

<style scoped lang="scss">
    .restart-chat-button {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;

        > button {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: var(--color-widget);
            color: var(--color-widget);
            cursor: pointer;
            padding: 10px 15px;
            margin: 0 0 1rem 0;
            transition: font-size 0.2s ease;
            user-select: none;
            font-size: 1rem;
            border-radius: 5px;
            border: 2px solid var(--color-widget);
            width: 200px;
            height: 45px;
            z-index: 0;

            &::before {
                content: '';
                background-color: white;
                border-radius: 7px; // inner border-radius + border-width
                position: absolute;
                inset: 0;
                opacity: 0.8;
                z-index: -1;
                pointer-events: none;
            }

            &:hover {
                font-size: 90%;
            }

            &:active {
                font-size: 85%;
            }
        }
    }

    .app--flat {
    }

    .app--modern {
    }
</style>
